import React, { forwardRef } from "react";
import Checkbox from "../../checkbox";
import { CheckBoxPaymentProps } from "../types/default-payment.types";
import classnames from "classnames";

export interface DefaultPaymentWithForwardRef
  extends React.ForwardRefExoticComponent<
    CheckBoxPaymentProps & React.RefAttributes<HTMLInputElement>
  > {}

export const DefaultPayment = forwardRef<
  HTMLInputElement,
  CheckBoxPaymentProps
>(
  (
    { label = "Save as default payment", ...props }: CheckBoxPaymentProps,
    ref
  ): React.ReactElement => {
    const classes = classnames("spark-clear", props.className);
    return (
      <>
        <Checkbox label={label} {...props} className={classes} ref={ref} />
      </>
    );
  }
) as DefaultPaymentWithForwardRef;

DefaultPayment.displayName = "DefaultPayment";
